import React from 'react';
import { useIntl } from 'react-intl';
import { Challenge, Maybe } from '../../../common/core-api';
import { useFile } from '../../../hooks';
import { removeTags } from '../../../helpers';
import { NotificationCardTypes } from '../../../common/enums';
import { RelativeDateWithTooltip, ResponsiveImage, Tooltip } from '../../../common/components';
import { NOTIF_STREAM_DEFAULT_IMAGE_HEIGHT } from '../../shared-constants';
import * as Styled from './ChallengeContent.styled';
import { Footer } from '.';

export const ChallengeContent = ({
  challenge,
  time,
  isValid
}: {
  challenge?: Maybe<Challenge>;
  time?: string;
  isValid: boolean;
}) => {
  const [getFile] = useFile();
  const intl = useIntl();

  const { id, files, title, description } = challenge || {};
  const challengeImage = files?.list;

  const imageResizeCallback = (width: number) => {
    if (!challengeImage) {
      return '';
    }

    return getFile({
      file: challengeImage,
      width,
      height: NOTIF_STREAM_DEFAULT_IMAGE_HEIGHT
    });
  };

  if (!challenge) {
    return null;
  }

  const message = intl.formatMessage({
    id: 'youNoLongerHaveAccessToThisItem',
    defaultMessage: 'You no longer have access to this item'
  });

  const clearTitle = removeTags(title || '');

  return (
    <Styled.ContentContainer>
      <Styled.ChallengeHeader>
        {isValid ? (
          <Styled.ChallengeTitle href={`/category/${id}`} target="_blank" rel="noreferrer">
            {clearTitle}
          </Styled.ChallengeTitle>
        ) : (
          <Tooltip content={message}>
            <Styled.ChallengeTitleGreyout target="_blank" rel="noreferrer">
              {clearTitle}
            </Styled.ChallengeTitleGreyout>
          </Tooltip>
        )}
        {time && <RelativeDateWithTooltip time={time} />}
      </Styled.ChallengeHeader>
      <Styled.ChallengeDescription lines={3} maxWidth="100%">
        {removeTags(description || '')}
      </Styled.ChallengeDescription>
      {challengeImage && (
        <Styled.ChallengeImageWrapper>
          <ResponsiveImage callback={imageResizeCallback} altText={title || ''} />
        </Styled.ChallengeImageWrapper>
      )}
      {isValid && <Footer challenge={challenge} type={NotificationCardTypes.CHALLENGE} />}
    </Styled.ContentContainer>
  );
};
